// This is needed to separate different types of modals that we may need later on, for exampel popover
const BASE_DIALOG_CLASSNAME = "base-dialog-modal";

export { BASE_DIALOG_CLASSNAME };
